import React, { Fragment } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

const ContactForm = () => {
    const { register, errors } = useForm({
        mode: "onBlur",
    });
    return (
        <Fragment>
            <form
                id="contactForm"
                className="row"
                action="https://forminit.com/f/5d1d9050-7207-4abd-a35b-c3b2eeb7dbc4"
                method="POST"
            >
                <div className="col-12 col-sm-6 mb-7">
                    <input
                        type="text"
                        className="form-control"
                        id="firstname"
                        name="firstname"
                        placeholder="Your First Name*"
                        ref={register({ required: "First name is required" })}
                    />
                    {errors.firstname && <p>{errors.firstname.message}</p>}
                </div>
                <div className="col-12 col-sm-6 mb-7">
                    <input
                        type="text"
                        className="form-control"
                        id="lastname"
                        name="lastname"
                        placeholder="Your Last Name*"
                        ref={register({ required: "Last name is required" })}
                    />
                    {errors.lastname && <p>{errors.lastname.message}</p>}
                </div>
                <div className="col-12 col-sm-6 mb-7">
                    <input
                        type="text"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder="Your Email*"
                        ref={register({
                            required: "Email is required",
                            pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                message: "invalid email address",
                            },
                        })}
                    />
                    {errors.email && <p>{errors.email.message}</p>}
                </div>
                <div className="col-12 col-sm-6 mb-7">
                    <input
                        type="tel"
                        className="form-control"
                        id="phone"
                        name="phone"
                        placeholder="Your Phone Number*"
                        ref={register({
                            required: "Phone number is required",
                            pattern: {
                                value: /^\d{10}$/, // Adjust this regex based on your phone number format
                                message: "Invalid phone number",
                            },
                        })}
                    />
                    {errors.phone && <p>{errors.phone.message}</p>}
                </div>
                <div className="col-12 mb-9">
                    <textarea
                        className="form-control massage-control"
                        name="message"
                        id="massage"
                        cols="30"
                        rows="10"
                        placeholder="Message"
                        ref={register({
                            required: "Message is required",
                        })}
                    ></textarea>
                    {errors.message && <p>{errors.message.message}</p>}
                </div>
                <div className="col-12 col-sm-12 mb-12">
                    <input type="checkbox" id="agree" name="agree" required />
                    <span className="form-label">
                        &#160;By checking this box, you agree to receive text
                        messages from BunnySpire LLC regarding your hiring
                        process at the number provided. Message frequency may
                        vary. Reply STOP to opt out at any time. Msg and data
                        rates may apply. View our&#160;
                        <Link
                            className="footer-link"
                            to={process.env.PUBLIC_URL + "/terms-conditions"}
                        >
                            Terms
                        </Link>{" "}
                        &{" "}
                        <Link
                            className="footer-link"
                            to={process.env.PUBLIC_URL + "/privacy-policy"}
                        >
                            Privacy Policy
                        </Link>
                        .
                    </span>
                    {errors.agree && <p>{errors.agree.message}</p>}
                </div>
                <div className="col-12">
                    <button
                        id="contactSubmit"
                        type="submit"
                        className="btn btn-dark btn-hover-dark"
                        data-complete-text="Well Done!"
                    >
                        Send Message
                    </button>
                </div>
            </form>
        </Fragment>
    );
};

export default ContactForm;
